import { track } from '@fff-web/fff-analytics';
import { FORM_INPUT_EVENT, FORM_TYPE_INTRO_PRODUCT } from './constants';

const trackFormInput = (inputField: string) => {
  track({
    trackName: FORM_INPUT_EVENT,
    properties: {
      form_type: FORM_TYPE_INTRO_PRODUCT,
      input_field: inputField,
    },
  });
};

export {
  // eslint-disable-next-line import/prefer-default-export
  trackFormInput,
};
